<button
    #inputElement
    color="primary !text-primary-800"
    (click)="onClick()"
    type="button"
    mat-button
>
    {{ params.label ?? params.value }}
</button>
